import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {
	recordTicketTimeRegistrationMutation,
	RecordTicketTimeRegistrationInput,
} from './__generated__/recordTicketTimeRegistrationMutation.graphql';

// Records that a Forecast time registration was logged through this ticket.
// Runs right after createTimeReg: the registration lives in Forecast, this makes
// it show up as the ticket's own time rather than as task time.
//
// Re-selecting TimeTab_ticket means the payload refreshes the tab's rows and stat
// cards from the Relay store, without waiting for the detail refetch.
const mutation = graphql`
	mutation recordTicketTimeRegistrationMutation($input: RecordTicketTimeRegistrationInput!) {
		recordTicketTimeRegistration(input: $input) {
			clientMutationId
			ticket {
				id
				...TimeTab_ticket
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: RecordTicketTimeRegistrationInput,
	onCompleted?: (r: recordTicketTimeRegistrationMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<recordTicketTimeRegistrationMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'recordTicketTimeRegistrationMutation'};
